module.exports = __webpack_public_path__ + "static/img/ARAD-S2_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD-S2_2.png
// module id = ZEJv
// module chunks = 0